import { Component, Inject, OnDestroy, OnInit, PLATFORM_ID } from '@angular/core';
import { AuthService, CheckpointService, ConfigService, FederalSubjectsService } from '@app/core/services';
import { Config, User } from '@app/entity';
import { animations } from '@app/shared/navigation/navigation.animations';
import { LockScrollService } from '@app/shared/lock-scroll.service';
import { WINDOW } from '@modules/window-token/window-token.module';
import { isPlatformBrowser } from '@angular/common';
import { Observable } from 'rxjs/Observable';
import { City } from '@app/entity/city';

interface NavigationMenu {
  title: string;
  path?: string;
  externalLink?: string;
  routerLinkActiveOptions?: any;
}

@Component({
  selector: 'app-navigation',
  animations: animations,
  templateUrl: './navigation.component.html',
  styleUrls: ['./navigation.component.scss']
})
export class NavigationComponent implements OnInit, OnDestroy {
  user: User;

  profileLink: any[];  // router commands

  isNavbarOverlayOpen: boolean;
  isScrollLocked: boolean;

  city: City;
  cities: Observable<City[]> = this.federalSubjectsService.cities;
  config: Config;

  navigationMenu: NavigationMenu[] = [
    {
      title: 'О платформе',
      path: '/about',
    },
    {
      title: 'Помощь',
      externalLink: 'https://form.pamyatpokoleniy.ru/',
    },
    {
      title: 'Новости',
      path: '/magazine/news',
    },
    // {
    //   title: 'Скидки',
    //   path: '/stocks',
    // },
    {
      title: 'Вакансии',
      externalLink: 'https://veterans.superjob.ru/',
    },
    {
      title: 'Отзывы',
      path: '/feedbacks',
    },
    // {
    //   title: 'Форум',
    //   externalLink: 'https://форум.ветераны.рф/'
    // },
    // {
    //   title: 'Курсы',
    //   externalLink: 'https://курсы.ветераны.рф/'
    // }
  ];


  constructor(
    private checkpoint: CheckpointService,
    private authService: AuthService,
    private lockScrollService: LockScrollService,
    private federalSubjectsService: FederalSubjectsService,
    private configService: ConfigService,
    @Inject(WINDOW) private window: any,
    @Inject(PLATFORM_ID) private platformId: Object,
  ) {
    this.authService.user
      .subscribe(u => {
        this.user = u;
        this.updateProfileLink(u);
      });
    // todo unsubscribe
    this.configService.config
      .subscribe(config => this.config = config);
  }

  ngOnInit() {
    this.lockScrollService.isScrollLocked
      .subscribe(isLocked => this.isScrollLocked = isLocked);

    this.updateProfileLink(this.user);

    this.listenOpenedNavbarOverlay();

    this.federalSubjectsService.city
      .subscribe(c => this.city = c);
  }

  ngOnDestroy() {
    if (!this.isNavbarOverlayOpen && this.isScrollLocked) this.lockScrollService.releaseScrollLock();
  }

  updateProfileLink(user) {
    if (user) {
      switch (user.user_type) {
        case 'partner':
          this.profileLink = ['/partner/profile'];
          break;
        case 'veteran':
          this.profileLink = ['/veteran/profile'];
          break;
        default:
          this.profileLink = null;
      }
    }
  }

  auth() {
    this.checkpoint.createCheckpoint();
  }

  logout() {
    this.authService.logout();
  }

  toggleNavbarOverlay() {
    this.isNavbarOverlayOpen = !this.isNavbarOverlayOpen;
    if (this.isNavbarOverlayOpen) {
      this.lockScrollService.requireScrollLock();
    } else {
      this.lockScrollService.releaseScrollLock();
    }
  }

  listenOpenedNavbarOverlay() {
    if (!isPlatformBrowser(this.platformId)) return;

    this.window.onresize = () => {
      if (this.window.innerWidth > 768) {
        if (this.isScrollLocked && this.isNavbarOverlayOpen) {
          this.lockScrollService.releaseScrollLock();
          this.isNavbarOverlayOpen = false;
        }
      }
    };
  }

  setCity(city: City) {
    this.federalSubjectsService.setCity(city);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/navigation/navigation.component.ts